import { getCurrentInstance, computed, ref } from '@vue/composition-api'

export default function useWidget () {
    const vm = getCurrentInstance().proxy
    const STORE_KEY = '$_dashboard'
    const store = vm.$store
    const widgetCardModel = computed(() => store.getters[`${STORE_KEY}/widgetCardModel`])
    const cardModels = ref(widgetCardModel.value || [])
    const handleWidgetCardModel = (value) => {
        // store.commit('appConfig/UPDATE_RESET_MODE', false)
        store.commit(`${STORE_KEY}/FETCH_MODEL_WIDGET`, value)
    }

    return {
        cardModels,
        widgetCardModel,
        handleWidgetCardModel
    }
}
